import fp from 'lodash/fp';
import React, { useEffect, useMemo, useCallback } from 'react';
import { formatDate } from '@factorin/util';

import { useSelector, useAction } from 'Modules/core/redux';
import { Button, Select } from 'Modules/ui2/components';
import { cn } from 'Modules/ui2/utils';
import { useTranslation } from 'Modules/core/i18n';

import { certificatesActions } from '../../state/certificates/actions';
import styles from './index.module.scss';


export const CertificateSelector2 = ({
    className,
    path,
    hideDisabled,
    disabled,
    forceDirection,
}) => {
    const { t } = useTranslation('certificateSelector');

    const { selected, available, error } = useSelector(`certificates[${path}]`);
    const updateCertificateList = useAction(certificatesActions.updateList);

    const update = useCallback(
        () => {
            updateCertificateList(path, {});
        },
        [path, updateCertificateList],
    );
    useEffect(update, [update]);

    const options = useMemo(
        () => (available || []).map(
            ({ name, thumbprint, disabled, validTo, reason }) => ({
                value: thumbprint,
                label: disabled
                    ? `${name} (${t(`errors.${reason}`)})`
                    : t('label', { name, date: formatDate(validTo) }),
                disabled,
            }),
        ).filter(hideDisabled ? opt => !opt.disabled : fp.identity),
        [available, hideDisabled, t],
    );

    const onChange = useAction(
        value => certificatesActions.setCertificate(path, { cert: value }),
        [path],
    );
    return (
        <div className={cn(styles.selector, className)}>
            <Button
                variant='background'
                size='48'
                className={cn(styles.button, error && styles.error)}
                disabled={disabled}
                onClick={update}
            >
                {t('refresh')}
            </Button>
            <Select
                className={cn(styles.select, error && styles.error)}
                disabled={disabled}
                options={options}
                value={selected}
                onChange={onChange}
                error={error && `${error}`}
                label={t('placeholders.normal')}
                noOptionsPlaceholder={t('placeholders.noResult')}
                direction={forceDirection}
            />
        </div>
    );
};
